import React, { useState, useEffect, ChangeEvent, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import SignInParams from '../../auth/types/SignInParams';
import signIn from '../../auth/api/signIn';

const LoginForm: React.FC = () => {
  const navigate = useNavigate();
  const [facilityCode, setFacilityCode] = useState<string>("")
  const [password, setPassword] = useState<string>("")
  const [alertMessageOpen, setAlertMessageOpen] = useState<boolean>(false)
  const [alertMessages, setAlertMessages] = useState<string[]>([]);
  const [isRemember, setIsRemember] = useState<boolean>(false);
  const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  useEffect(() => {
    const storedIsRemember = localStorage.getItem("isRemember");
    const storedRememberId = localStorage.getItem("rememberId");
    if(storedIsRemember) {
      setIsRemember(JSON.parse(storedIsRemember));
    }
    if(storedRememberId) {
      setFacilityCode(JSON.parse(storedRememberId));
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    
    if (!recaptchaToken) {
      setAlertMessageOpen(true);
      setAlertMessages(['reCAPTCHA認証を完了してください。']);
      return;
    }
    
    const params: SignInParams = {
      facility_code: facilityCode,
      password: password,
      recaptcha_token: recaptchaToken
    }

    try {
      await signIn(params);
      setAlertMessageOpen(false);
      if(isRemember) {
        localStorage.setItem("rememberId", JSON.stringify(facilityCode));
        localStorage.setItem("isRemember", JSON.stringify(isRemember));
      } else {
        const storedRememberId = localStorage.getItem("rememberId");
        if(storedRememberId) {
          localStorage.removeItem("rememberId");
          localStorage.removeItem("isRemember");
        }
      }

      navigate('/facility/top');
    } catch (err: any) {
      setAlertMessageOpen(true);
      if (err.response && err.response.data && err.response.data.errors) {
        setAlertMessageOpen(true);
        setAlertMessages(err.response.data.errors);
      } else {
        setAlertMessageOpen(false);
        console.log('An unexpected error occurred:', err);
      }
      // Reset reCAPTCHA on error
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
        setRecaptchaToken(null);
      }
    }
  }

  const messages = alertMessages.length === 0 ? '' : alertMessages.map((message: string, index: number) =>
    <li key={index}>{message}</li>
  )
  
  const handleRecaptchaChange = (token: string | null) => {
    setRecaptchaToken(token);
  };
  
  const handleRecaptchaExpired = () => {
    setRecaptchaToken(null);
  };

  return (
    <React.Fragment>
      <div className="correct-box__form">
        <h2 className="correct-box__form-ttl">お取引先ページ（ご注文等）はこちら</h2>
        { alertMessageOpen &&
          <div className="contact-note" style={{marginTop: '20px', marginBottom: '0px'}}>
            <ul>
              { messages }
            </ul>
          </div>
        }
        <div className="correct-box__form-ct">
          <form onSubmit={handleSubmit}>
            <div className="correct-box__form-item">
              <label className="correct-box__form-lable" htmlFor="facility_code">ログインID (施設コードNo)</label>
              <input
                name="facility_code"
                type="text"
                className="input"
                id="facility_code"
                value={facilityCode}
                onChange={event => setFacilityCode(event.target.value)}
              />
            </div>
            <div className="correct-box__form-item">
              <label className="correct-box__form-lable" htmlFor="password">パスワード (初回は電話番号)</label>
              <input
                name="password"
                type="password"
                className="input"
                id="password"
                onChange={event => setPassword(event.target.value)}
              />
            </div>
            <label className="checkbox-item correct-box__form-check">
              <input type="checkbox"
                checked={isRemember}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setIsRemember(e.target.checked)
                }}
              />
              <span className="checkmark"></span> IDを記憶しておく </label>
            <div style={{ marginTop: '20px', marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}
                onChange={handleRecaptchaChange}
                onExpired={handleRecaptchaExpired}
              />
            </div>
            <button type="submit" className="c-btn__01" disabled={!recaptchaToken}>ログイン</button>
            <div className="correct-box__form-privacy"><a href="/facility/forgot_password">※パスワードをお忘れの方はこちら</a></div>
          </form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default LoginForm;